import type { FC } from 'react';
import type { XpTransaction } from 'src/types/xp';

import React from 'react';
import { ArrowUp, ArrowDown } from '@phosphor-icons/react';

import { formatDay } from 'src/utils/date';
import { formatXpAmount, getXpTransactionScopeLabel } from 'src/utils/xp';

import { ListItem } from 'src/components/ListItem';
import { Image } from 'src/components/themed/Image';

import { XpTransactionType } from 'src/types/xp';

interface XpTransactionItemProps {
  transaction: XpTransaction;
}

/** A row of the XP ledger. It leads nowhere — there is no screen for a single transaction. */
export const XpTransactionItem: FC<XpTransactionItemProps> = ({ transaction }) => {
  const isEarned = transaction.type === XpTransactionType.REFILL;
  const icon = isEarned ? (
    <ArrowUp color="#00ff00" size={24} />
  ) : (
    <ArrowDown color="#ff0000" size={24} />
  );

  return (
    <ListItem
      icon={<Image size="small" icon={icon} />}
      title={getXpTransactionScopeLabel(transaction.scope)}
      description={formatDay(transaction.createdAt)}
      amount={formatXpAmount(transaction.amount, transaction.type)}
    />
  );
};
